import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const MegaNewsContainer = styled.article.attrs((props) => ({
  className: props.className,
}))`
  .mega-header {
    position: relative;
    .shared-header {
      display: flex;
      flex-direction: column-reverse;
    }
    .image-container {
      position: relative;
      padding-bottom: 17px;
      ${breakpoints.phone} {
        left: 50%;
        transform: translateX(-50%);
        width: 100vw;
        padding-bottom: 0;
      }

      .bkg {
        height: 100%;
      }

      .picture-open {
        z-index: 1;
      }
      .freeHtml {
        width: 100vw;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .mt {
      padding: 20px 0 0 0 !important;
    flex-direction:column;
      ${breakpoints.mobileFirst} {
        position: absolute;
        bottom: 50px!important;
        left: 50%;
        transform: translateX(-50%);
        color: ${Color.white};
        z-index: 1;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      ${breakpoints.tablet} {
        bottom: 550px;
      }
      span {
        ${Font.clarinVarSub2Regular};
        color: ${Color.mainColor};
        font-size: 28px;
        line-height: 33px;
        letter-spacing: -0.28px;
        ${breakpoints.mobileFirst} {
          display: flex;
          font-size: 42px;
          line-height: 55px;
          letter-spacing: -0.42px;
          color: ${Color.white};
        }
      }

      h1 {
        bottom: inherit;
        ${Font.clarinVarSub2Bold};
        font-size: 28px;
        line-height: 33px;
        letter-spacing: -0.28px;
        ${breakpoints.mobileFirst} {
          height: 100%;
          color: white;
          width: 50%;
          text-align: center;
          font-size: 42px;
          line-height: 48px;
          letter-spacing: -0.42px;
          position: unset;
        }
      }

      .icon-paywall-box {
        p {
          color: ${Color.black000};
        }
        ${breakpoints.mobileFirst} {
          width: 100%;
          justify-content: center;
          z-index: 1;
          p {
            color: white;
          }
        }
      }

      ${breakpoints.phone} {
        width: 100%;
      }
    }
    .epigraphe {
      display: none;
    }
  }
  .storySummary {
    padding-bottom: 30px;
  }
`;

export const HeaderMega = styled.article.attrs((props) => ({
  className: props.className,
}))`
  .main-image {
    .freeHtml {
      width: 100vw;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
    .main-title-container {
      .icon-paywall-box {
        p {
          color: ${Color.black000};
        }
        ${breakpoints.mobileFirst} {
          width: 100%;
          justify-content: center;
          bottom: 48px;
          z-index: 1;
          p {
            color: white;
          }
        }
      }
      ${breakpoints.phone} {
        width: 100%;
        padding: 0 12px;
      }
    }
    .picture-open {
      z-index: 1;
    }
    .bkg {
      position: absolute;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.55)
      );
      bottom: 20px;
      height: 100%;
      width: 100%;
      left: 0;
      ${breakpoints.phone} {
        background-image: none;
      }
    }
  }
  .title-container {
    .mt {
      .storySummary {
        color: ${Color.grey};
        ${Font.sansRegular};
        font-size: 22px;
        line-height: 36px;
        letter-spacing: -0.22px;
        text-decoration: none;
        padding-bottom: 30px;
        ${breakpoints.phone} {
          font-size: 18px;
          line-height: 23px;
          letter-spacing: -0.18px;
          padding-bottom: 40px;
        }
        a {
          color: ${Color.mainColor};
          &:before {
            background: ${Color.mainColor};
            border-radius: 4px;
            content: " ";
            display: inline-block;
            height: 4px;
            width: 4px;
            margin-right: 6px;
            transition-duration: 0.3s;
            vertical-align: middle;
          }
          &:hover {
            color: ${Color.black};
          }
        }
        ul li {
          &:before {
            background: ${Color.grey};
            border-radius: 4px;
            content: " ";
            display: inline-flex;
            height: 4px;
            width: 4px;
            margin-right: 6px;
            transition-duration: 0.3s;
            vertical-align: middle;
          }
        }
      }
    }
  }
`;
export const DataStory = styled.section.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 1rem;
  width: 100%;
  column-gap: 1rem;
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
    }
  }
  ${breakpoints.phone} {
    flex-direction: column;
    border-top: 1px solid #e0e0e0;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-top: 1px solid ${ColorDark.greySeparator};
      }
    }
  }
  .list-authors {
    ${breakpoints.phone} {
      align-self: start;
    }

    display: block;
    ${Font.sansSemiBold};
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0px;
    line-height: 21px;
    padding-right: 0.3rem;

    ${breakpoints.phone} {
      width: 100%;
      padding: 0.5rem 0;
    }
  }

  .place-social-mobile {
    display: flex;
    align-items: center;

    ${breakpoints.phone} {
      width: 100%;
      border-top: 1px solid #e0e0e0;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-top: 1px solid ${ColorDark.greySeparator};
        }
      }
    }
  }
  .SocialMedia {
    border-top: none;
  }
`;
